import * as React from "react"
import {Box, Typography} from "@mui/material";

import { ImageSkuBlock } from "@components"
import {productDetailsEvolutionCurrentSkuData, productDetailsEvolutionSelectedSku} from "../../@signals";


export default function MarketplacesProductDetailsEvolutionSkuInfo() {
	return <Box>
		<ImageSkuBlock
			skuID={productDetailsEvolutionSelectedSku.value}
			skuName={productDetailsEvolutionCurrentSkuData.value.sku}
			isClickable={false}
			contentProps={{
				sx: { width: 1, height: "auto", borderRadius: 2, margin: "0 auto" }
			}}
		/>

		<Box sx={{ mt: 3 }}>
			<Typography variant="subtitle2">
				{productDetailsEvolutionCurrentSkuData.value.sku}
			</Typography>
			<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
				Category: {productDetailsEvolutionCurrentSkuData.value.category}
			</Typography>
			<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
				Brand: {productDetailsEvolutionCurrentSkuData.value.brand}
			</Typography>
			{ !!productDetailsEvolutionCurrentSkuData.value.ean && <Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
				EAN: {productDetailsEvolutionCurrentSkuData.value.ean}
			</Typography> }
		</Box>
	</Box>
}